// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import ProfilePage from './ProfilePage';
//
// const RenderProfilePage = () => {
//     const phone = localStorage.getItem('phoneNumber');
//     const isCodeVerified = localStorage.getItem('isCodeVerified') === 'true';
//     const verificationTime = localStorage.getItem('verificationCodeTime');
//
//     const TWO_MINUTES = 2 * 60 * 1000; // 2 минуты в миллисекундах
//     const now = Date.now();
//     const isExpired = verificationTime && (now - Number(verificationTime) > TWO_MINUTES);
//
//     // Если номер телефона отсутствует — переходим на модалку ввода номера
//     if (!phone) {
//         return <Navigate to="/phone-number-modal" />;
//     }
//
//     // Если код просрочен и номер телефона есть — переходим на повторную верификацию
//     if (isExpired) {
//         localStorage.removeItem('isCodeVerified');
//         localStorage.removeItem('verificationCode');
//         localStorage.removeItem('verificationCodeTime');
//         return <Navigate to="/verify-code-restart2" state={{ phone, flag: 'profile' }} />;
//     }
//
//     // Если код не подтвержден — также на повторную верификацию
//     if (!isCodeVerified) {
//         return <Navigate to="/verify-code-restart2" state={{ phone, flag: 'profile' }} />;
//     }
//
//     return <ProfilePage />;
// };
//
// export default RenderProfilePage;


import React from 'react';
import { Navigate } from 'react-router-dom';
import ProfilePage from './ProfilePage';

const RenderProfilePage = () => {
    const phone = localStorage.getItem('phoneNumber');
    const userIdCreatedAt = localStorage.getItem('userId_createdAt'); // формат: 2025-06-28T03:23:19.880Z
    const now = new Date();

    let isOlderThanOneMinute = false;

    if (userIdCreatedAt) {
        const createdAt = new Date(userIdCreatedAt);
        const diffInMs = now.getTime() - createdAt.getTime();
        isOlderThanOneMinute = diffInMs > 60 * 1000;
    }

    // === Условие 1 ===
    // если userId_createdAt > 1 мин и phoneNumber отсутствует — перейти на phoneNumberModal
    if (isOlderThanOneMinute && !phone) {
        return <Navigate to="/phone-number-modal" />;
    }

    // === Условие 2 ===
    // если userId_createdAt > 1 мин и phoneNumber присутствует — повторная верификация
    if (isOlderThanOneMinute && phone && !userIdCreatedAt) {
        return <Navigate to="/verify-code-restart2" state={{ phone, flag: 'profile' }} />;
    }

    // === Условие 3 ===
    // если userId_createdAt <= 1 мин и есть phoneNumber — переходим на профиль
    if (!isOlderThanOneMinute && phone) {
        return <ProfilePage />;
    }

    // fallback — редирект на ввод номера
    return <Navigate to="/phone-number-modal" />;
};

export default RenderProfilePage;
